// extracted by mini-css-extract-plugin
export default {"container":"container__VepSubmissionError__40zuZ","errorText":"errorText__VepSubmissionError__40zuZ"};